<template>
  <div>
    <Section>
      <SectionHeader :title="$t('apps.hrm.message.general')"/>
      <FormRow>
        <Col className="col-lg-6">
        <Label :text="`${$t('apps.hrm.message.name')} *`" />
        <BaseInput
          v-model="$v.input.name.$model"
          :classNames="[{ 'is-invalid': $v.input.name.$error }]"
          :disabled="disabled"
        />
        </Col>
      </FormRow>
    </Section>

    <Section v-if="input.name">
      <SectionHeader :title="$t('apps.hrm.message.assignemployee')"/>
      <FormRow>
        <Col className="col-lg-12">
        <BaseNotFoundData
          v-if="!employees.length"
          :title="$t('apps.payroll.message.notfoundemployeee')"
          :detail="$t('apps.payroll.message.createnewemployee')"
        />
        <BaseAssignItems
          v-else
          v-model="input.assignIds"
          :items="assignitems"
          :primaryId="primaryId"
          :primaryName="primaryName"
          :disabled="disabled"
        />
        </Col>
      </FormRow>
    </Section>

    <BaseFormAction
      v-if="showActionButtons"
      :textCancel="$t('button.cancel')"
      :textSubmit="$t('button.save')"
      :isSubmitted="isSubmitted"
      @onCancel="handleCancel"
      @onSubmit="handleSubmit"
    />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import _ from 'lodash'

export default {
  props: ['state', 'isSubmitted', 'disabled', 'employees', 'showActionButtons'],

  data () {
    return {
      input: {
        name: null,
        assignIds: [],
      },
      inputOriginal: null,
    }
  },

  validations: {
    input: {
      name: {
        required,
      },
    },
  },

  computed: {
    assignitems () {
      return this.employees.map((item) => {
        return {
          text: item.name,
          value: item.empId,
          primaryId: item.departmentId,
          primaryName: item.departmentName,
        }
      })
    },
    primaryId () {
      return this.state ? this.state.depId : null
    },
    primaryName () {
      return this.state ? this.state.name : this.input.name
    },
  },

  watch: {
    input: {
      handler: function () {
        this.$emit('update:form', this.input)
      },
      deep: true,
    },
  },

  created () {
    if (this.state) {
      this.setInput(this.state)
    } else {
      this.inputOriginal = _.cloneDeep(this.input)
    }
  },

  methods: {
    handleCancel () {
      if (this.$listeners.onCancel) {
        this.$emit('onCancel')
      } else {
        this.input = _.cloneDeep(this.inputOriginal)
        this.scrollToTop(600)
      }
    },
    handleSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.scrollToTop(600)
      } else {
        this.$emit('onSubmit', this.input)
      }
    },
    setInput (state) {
      this.input.name = state.name
      this.input.assignIds = _.cloneDeep(state.empIds)
      this.inputOriginal = _.cloneDeep(this.input)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/combine/HrmDepartmentForm.vue